/**
 * Checks if at least one of the form fields is not empty, in which case form is dirty
 * @param  {Object} objectValues - form fields to check
 * @return {boolean} Returns true if the form is dirty
 */
export default function isDirty(objectValues) {
  var valuesKeys = Object.keys(objectValues);
  if (!valuesKeys.length) return false;

  for (var _i = 0; _i < valuesKeys.length; _i++) {
    var key = valuesKeys[_i];

    if (objectValues[key] || objectValues[key] === 0 || objectValues[key] === false) {
      return true;
    }
  }

  return false;
}